module.exports = __webpack_public_path__ + "static/media/WO.5949a1ab.png";